import { Icon } from "../actions/Icon";
import { ModeTile } from "../recording/ModeTile";

const visibilityLevels = [
  { value: "private", icon: "lock-simple", label: "Private" },
  { value: "people", icon: "user", label: "People" },
  { value: "team", icon: "users", label: "Team" },
  { value: "org", icon: "buildings", label: "Org" },
  { value: "public", icon: "globe", label: "Public" },
] as const;

/**
 * The five visibility levels: Private, People, Team, Org, Public. Tiles on desktop, radio list on mobile.
 */
export interface VisibilityPickerProps {
  value?: "private" | "people" | "team" | "org" | "public";
  onChange?: (value: string) => void;
  layout?: "tiles" | "list";
  className?: string;
}

export function VisibilityPicker({ value = "org", onChange, layout = "tiles", className }: VisibilityPickerProps): JSX.Element {
  if (layout === "list") {
    return (
      <div role="radiogroup" className={["gk-vis", "gk-vis--list", className].filter(Boolean).join(" ")}>
        {visibilityLevels.map((l) => (
          <button
            key={l.value}
            type="button"
            role="radio"
            aria-checked={value === l.value}
            className="gk-vis__row"
            onClick={() => onChange?.(l.value)}
          >
            <Icon name={l.icon} size={22} />
            <span className="gk-vis__label">{l.label}</span>
            <span className="gk-vis__radio" />
          </button>
        ))}
      </div>
    );
  }
  return (
    <div role="radiogroup" className={["gk-vis", className].filter(Boolean).join(" ")}>
      {visibilityLevels.map((l) => (
        <ModeTile
          key={l.value}
          compact
          icon={l.icon}
          label={l.label}
          selected={value === l.value}
          onClick={() => onChange?.(l.value)}
        />
      ))}
    </div>
  );
}
